import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { teamService } from '@/services/teamService';
import { PageLayout } from '@/components/layout/PageLayout';
import TeamsPage from '@/pages/app/Teams';
import { Skeleton } from '../ui/skeleton';

/**
 * Component that handles team routing logic
 * - If user has teams, redirects to first team details
 * - If user has no teams, shows team creation page
 */
export const TeamRedirect: React.FC = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [hasTeams, setHasTeams] = useState(false);

    useEffect(() => {
        const checkUserTeams = async () => {
            try {
                setLoading(true);
                const data = await teamService.getUserTeams();

                if (data.teams.length > 0) {
                    // User has teams, redirect to first team details
                    const firstTeam = data.teams[0];
                    navigate(`/app/teams/${firstTeam.team.id}`, { replace: true });
                } else {
                    // User has no teams, show teams page for creation
                    setHasTeams(false);
                    setLoading(false);
                }
            } catch (error) {
                console.error('Failed to load teams:', error);
                setLoading(false);
            }
        };

        checkUserTeams();
    }, [navigate]);

    if (loading) {
        return (
            <PageLayout nav={true} footer={true}>
                <div className="px-4 py-10 mx-auto max-w-6xl w-full">
                    <div className="space-y-6">
                        <Skeleton className="h-8 w-32" />
                        <div className="grid gap-6 md:grid-cols-2">
                            <Skeleton className="h-48 rounded-xl" />
                            <Skeleton className="h-48 rounded-xl" />
                        </div>
                    </div>
                </div>
            </PageLayout>
        );
    }

    if (!hasTeams) {
        // Show the teams page for team creation
        return <TeamsPage nav={true} footer={true} />;
    }

    // This should never render as we redirect above
    return null;
};
